import { Component, Input } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Lote } from 'src/app/models/Lote.model';
import { LoteService } from 'src/app/core/services/lote.service';
import { LoteDetalleUrlService } from 'src/app/core/services/lote-detalle-url.service';
import { LoteCertificadoService } from 'src/app/core/services/lote-certificado.service';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { LoteDetalleUrlCoordenadaService } from 'src/app/core/services/lote-detalle-url-coordenada.service';
import { PlantillasService } from 'src/app/core/services/plantilla.service';
import { Plantilla } from 'src/app/models/Plantilla.model';
import { LoteCertificado } from 'src/app/models/LoteCertificado.model';
import { LoteDetalleUrl } from 'src/app/models/LoteDetalleUrl.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { PlantillaCoordenada } from 'src/app/models/PlantillaCoordenada.model';
@Component({
    selector: 'asociacion-firma-plantilla',
    templateUrl: './asociacion-firma-plantilla.component.html',
    styleUrls: ['./asociacion-firma-plantilla.css']
})
export class AsociacionFirmaPlantillaComponent {

    @Input() dataPlantilla: Plantilla;
    private idLote: any = null;
    private lote: Lote;
    public loteDetalleUrls: LoteDetalleUrl[] = [];

    public documentPdfUrl: SafeResourceUrl | null = null;
    public loteCertificados: LoteCertificado[] = [];
    public loteDetalleUrlId: number;
    public estado: string;

    public plantillaCoordenadas: PlantillaCoordenada[] = [];
    public detalleShowDocument: Plantilla[] = [];
    public certificado = [];

    toast = Swal;

    public hora = '';
    public minutos = '';
    public segundos = '';

    constructor(
        private loteDetalleUrlService: LoteDetalleUrlService,
        private firmaStateService: FirmaStateService,
        private loteCertificadoService: LoteCertificadoService,
        private LoteDetalleUrlCoordenadaService: LoteDetalleUrlCoordenadaService,
        private LoteService: LoteService,
        private plantillaService: PlantillasService,
        private sanitizer: DomSanitizer
    ) {

    }
    async ngOnInit() {
        this.toastAlert();
        this.actualizarHora();
        this.showDocumentPlantilla();

    }

    async showDocumentPlantilla() {
        const response = await lastValueFrom(this.plantillaService.showDocumenPlantilla(this.dataPlantilla.id));
        this.detalleShowDocument = [response.body as Plantilla];

    }

    async selectDocument(loteDetalleUrlId: number) {

        this.loteDetalleUrlId = loteDetalleUrlId;
        this.listCertificado();
        const { body } = await lastValueFrom(this.plantillaService.viewDocumenPlantilla(this.dataPlantilla.id));
        const base64String = body?.url_documento;

        const dataUrl = `data:application/pdf;base64,${base64String}`;
        this.documentPdfUrl = this.convertBase64ToUrl(dataUrl);
    }

    convertBase64ToUrl(base64String: string): string {
        const byteCharacters = atob(base64String.split(',')[1]);  // Decodifica Base64 a caracteres binarios
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset++) {
            const byte = byteCharacters.charCodeAt(offset);
            byteArrays.push(byte);
        }

        const byteArray = new Uint8Array(byteArrays);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);  // Crea una URL de objeto
        return url;
    }

    async addCertificado(data: any) {
        const response = await lastValueFrom(this.plantillaService.addCoordenadasPlantilla(data, this.dataPlantilla.id));

        if (response) {
            this.listCertificado();
            this.actualizarHora();
            this.alert('success', 'Firma guardada correctamente');
        }
    }

    async listCertificado() {
        const response = await lastValueFrom(this.plantillaService.getCordenadasPlantilla(this.dataPlantilla.id));
        this.plantillaCoordenadas = (response.body) as PlantillaCoordenada[];
    }

    async deleteCoordenada(idCoordenadPlantilla: number) {

        const response = await lastValueFrom(this.plantillaService.deleteCoordenada(this.dataPlantilla.id, idCoordenadPlantilla));

        if (response) {
            this.listCertificado();
            this.actualizarHora();
            this.alert('success', 'Firma eliminada correctamente');
        }
    }

    actualizarHora(): void {
        const ahora = new Date();

        this.hora = String(ahora.getHours()).padStart(2, '0');
        this.minutos = String(ahora.getMinutes()).padStart(2, '0');
        this.segundos = String(ahora.getSeconds()).padStart(2, '0');
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }
}
